// ЭТАП 1 · Шаг 3 — SSR-safe: на сервере window нет (вызывается на module-eval
// из CartStore: configure({ useProxies: IEdetector() ? ... })).
export const IEdetector = () =>
  typeof window !== 'undefined' &&
  (window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1);
